import {Permission} from "../Apis/Models/IUserDto";

export const canAccess = (permissions: Permission[], requestedPermission: Permission) => {
    return permissions.includes(requestedPermission);
}